import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  description: {
    marginTop: 4,
    marginBottom: 20
  },
  confirmationInfoLabel: {
    color: theme.palette.text.secondary,
    fontSize: 12,
    marginBottom: 4
  },
  confirmationInfoText: {
    color: theme.palette.text.primary,
    fontSize: 14,
    marginTop: 4
  },
  buttonDeleteEntry: {
    color: "#d9001b",
    fontWeight: "bold"
  }
}));
